import { v4 as uuidv4 } from 'uuid';
import bankChurnImg from '../images/bankImg.jpg';
import cocktailImg from '../images/cocktailImg.webp';
import handImg from '../images/handImg.jpg';
import musicImg from '../images/music.jpg';
import heartImg from '../images/heartImg.png';
import handWritten from '../images/handWritten.jpg';

const projects = [
  {
    id: uuidv4(),
    name: 'Bank Churn Prediction',
    desc: 'This project employs machine learning to help banks anticipate customer churn and implement effective retention strategies.',
    img: bankChurnImg,
    link: 'https://github.com/NandiSoham/Bank-Churn-Prediction',
  },
  {
    id: uuidv4(),
    name: 'Heart Disease Prediction',
    desc: 'This project uses machine learning to develop predictive models for heart disease diagnosis.',
    img: heartImg,
    link: 'https://github.com/NandiSoham/Heart-Disease-Prediction',
  },
  {
    id: uuidv4(),
    name: 'Cocktail Recommendtion System - RAG Application',
    desc: 'This project is a GenAI-based Retrieval-Augmented Generation (RAG) application for personalized cocktail recommendations.',
    img: cocktailImg,
    link: 'https://github.com/NandiSoham/Cocktail-Recommendation-System',
    linkLive: 'https://cocktail.streamlit.app/',
  },
  {
    id: uuidv4(),
    name: 'Handwritten Digit Recognition using ML',
    desc: 'This project involves developing a Convolutional Neural Network (CNN) to accurately recognize handwritten digits using the MNIST dataset, utilizing Python, TensorFlow, Keras.',
    img: handWritten,
    link: 'https://github.com/NandiSoham/Handwritten-Digit-Recognition-using-Machine-Learning-and-Deep-Learning',
    linkLive: 'https://handwrittendigitrecognition.streamlit.app/',
  },
  {
    id: uuidv4(),
    name: 'Game Automation with Hand Gestures',
    desc: 'This is an OpenCV based steering wheel that controls computer keyboard inputs (such as moving left or right) using hand gestures to play racing games.',
    img: handImg,
    link: 'https://github.com/NandiSoham/Car-Racing-Using-Realtime-Color-Detection',
  },
  {
    id: uuidv4(),
    name: 'PODLAX',
    desc: 'PODLAX is a user-friendly web application designed for a smooth and secure experience. It lets users enjoy music playback with high-quality audio features and ensures secure login using advanced authentication.',
    img: musicImg,
    link: 'https://github.com/NandiSoham/FullStack-Project---Podlax',
  },
];

export default projects;
